import { Component, OnInit, Input } from '@angular/core';
import { contentTransition } from "../../../animations";
import { QuibblService } from '../../../quibbl.service';
import { AuthService } from '../../../auth.service';

@Component({
  selector: 'app-quibbl-discussion',
  templateUrl: './quibbl-discussion.component.html',
  styleUrls: ['./quibbl-discussion.component.scss'],
  animations: [contentTransition()],
  host: {'[@routerTransition]': ''}
})
export class QuibblDiscussionComponent implements OnInit {

  public closed;
  public quibblSubscription;

  constructor(public qb: QuibblService,
              private auth: AuthService) { }

  ngOnInit() {
    this.quibblSubscription = this.qb.getQuibbl(this.qb.currentQuibblIdentifier).subscribe(quibbl => {
      this.closed = quibbl.closed;
    });
  }

  ngOnDestroy() {
    this.quibblSubscription.unsubscribe();
  }

  public submitComment(event) {
    if(!event || event == '') return;
    this.qb.postCommentToQuibbl(this.qb.currentQuibblIdentifier, this.auth.userIdentifier, event);
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component.ts